import angular from 'angular';

import { SimulacaoRescisaoListRouting } from './simulacaorescisao.routes';
import { SimulacaoRescisaoIndexController } from './index/simulacaorescisao.index.controller';

export const SimulacaoRescisaoModule = angular.module('SimulacaoRescisaoModule', ['ui.router.state'])
    .controller('SimulacaoRescisaoIndexController', SimulacaoRescisaoIndexController)
    .config(SimulacaoRescisaoListRouting)
    .name;
